/* eslint-disable no-shadow */
import { http } from "@/api/index";
import FetchStatus from "@/constants/fetch-status/FetchStatus";

import {
	GET_EVENTS_RECORDS,
	GET_EVENTS_RECORDS_SUCCESS,
	GET_EVENTS_RECORDS_ERROR,
} from "@/stores/actions/EventsRecords.js";

import { SET_EVENT_TABLE } from "@/stores/actions/EventsTable";

const state = {
	status: FetchStatus.Init,
	data:   [],
	error:  {},
};

const Qs = require("qs");

const actions = {

	[GET_EVENTS_RECORDS]: ({ commit, dispatch }, eventsSettings) =>
	{
		const eventSettingIds = eventsSettings.map(e => e.id);
		http.get("/EventsRecords", {
			params:           { eventSettingIds },
			paramsSerializer: params => Qs.stringify(params, { arrayFormat: "repeat" }),
		})
			.then((resp) =>
			{
				const params = {
					eventsSettings,
					eventsRecords: resp.data,
				};
				dispatch(SET_EVENT_TABLE, params);
				commit(GET_EVENTS_RECORDS_SUCCESS, resp.data);
			})
			.catch((error) =>
			{
				commit(GET_EVENTS_RECORDS_ERROR, error.response);
			});
	},
};

const mutations = {
	[GET_EVENTS_RECORDS]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_EVENTS_RECORDS_SUCCESS]: (state, resp) =>
	{
		state.data = resp;
		state.status = FetchStatus.Loaded;
	},
	[GET_EVENTS_RECORDS_ERROR]: (state, error) =>
	{
		state.error = error;
		state.status = FetchStatus.Error;
	},
};

export default {
	state,
	actions,
	mutations,
};
